import {canvasToBlob} from './';

export class Img {
    /**
     * get width & height of image
     * @param {File} file 
     * @param {Callback} fn
     */
    static getXY(file, cb) {
        var reader = new FileReader();
        
        reader.onload = function (e) {
            var image = new Image();
            image.src = e.target.result;

            image.onload = function () {
                if(typeof cb === 'function') cb(this.width, this.height);
            };
        }
        reader.readAsDataURL(file);
    }

    static svgToImage(svg, cb, options = {x: 100, y: 100, text: false, fontSize: null}) {
        canvasToBlob();

        const canvas = document.createElement('canvas');
        canvas.width = options.x;
        canvas.height = options.y;
        if(options.fontSize) canvas.height += options.fontSize * 2;

        const ctx = canvas.getContext('2d');
        const data = encodeURIComponent(svg);

        const img = new Image();
        img.onload = () => {
            ctx.drawImage(img, 0, 0, options.x, options.y);
            if(options.text) {
                ctx.font = `${options.fontSize}px "Arial"`;
                ctx.fillStyle = "black";
                ctx.textAlign = "center";
                ctx.fillText(options.text, canvas.width/2, canvas.height - options.fontSize*1.5); 
            }
            
            canvas.toBlob(function(blob) {
                const url = URL.createObjectURL(blob);
                cb(url);
            });
        }

        img.src = "data:image/svg+xml," + data;
    }

    // @source https://stackoverflow.com/questions/46405773/saving-base64-image-with-filesaver-js
    static base64ToBlob(base64) {
        const byteString = atob(base64.split(',')[1]);
        const mimeType = base64.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        
        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values 
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], {type: mimeType});
    }
}


// WEBPACK FOOTER //
// ./src/helper/img.js